import { isDefined } from '@eih-netbroker/common';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { useLayoutEffect, useState } from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/icons/information-line.svg';
import { ReactComponent as PasswordHidden } from '../../../assets/icons/password-hidden.svg';
import { ReactComponent as PasswordVisible } from '../../../assets/icons/password-visible.svg';
import translation from '../../data/translation/hu_HU';
import { cssWhen } from '../../utils/themeUtils';
import { NbLoader } from '../loader/Loader';
import { NbTooltip } from '../tooltip/Tooltip';
import classes from './TwoFactorField.module.scss';

type TwoFactorFieldProps = {
  label?: string;
  errorMessage?: string;
  isLoading?: boolean;
  showTooltip?: boolean;
} & TextFieldProps;

export const TwoFactorField = ({ label, errorMessage, isLoading, showTooltip, ...props }: TwoFactorFieldProps) => {
  const [showInput, setShowInput] = useState(false);
  const [inputHasChanged, setInputHasChanged] = useState(false);
  const showErrorBorder = !inputHasChanged && isDefined(errorMessage);

  useLayoutEffect(() => {
    setInputHasChanged(false);
  }, [errorMessage]);

  return (
    <div className={classes.wrapper}>
      <span className={classes.inputLabel}>{label}</span>
      <div className={classes.inputWrapper}>
        <TextField
          {...props}
          type={showInput ? 'text' : 'password'}
          className={cssWhen(classes.input, [showErrorBorder, classes.inputError])}
          inputProps={{ maxLength: 4 }}
          InputProps={{
            className: classes.orderFormRowQuantity,
            readOnly: isLoading,
            endAdornment: (
              <InputAdornment position="end">
                {isLoading && <NbLoader size="small" />}
                <IconButton
                  className={classes.inputAdornmentIconButton}
                  disabled={isLoading}
                  onClick={() => setShowInput(!showInput)}
                >
                  {showInput ? (
                    <PasswordVisible className={classes.inputAdornmentIcon} />
                  ) : (
                    <PasswordHidden className={classes.inputAdornmentIcon} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={e => {
            setInputHasChanged(true);
            if (props.onChange) {
              props.onChange(e);
            }
          }}
        />
        {showTooltip && (
          <NbTooltip title={translation.orderModal.twoFactorConfirm.info}>
            <InfoIcon className={classes.tooltip} />
          </NbTooltip>
        )}
      </div>
      {errorMessage && <span className={classes.errorHelperText}>{errorMessage}</span>}
    </div>
  );
};
